import { render, staticRenderFns } from "./BedbuilderShareOptions.vue?vue&type=template&id=95c6d308&scoped=true&"
import script from "./BedbuilderShareOptions.vue?vue&type=script&lang=js&"
export * from "./BedbuilderShareOptions.vue?vue&type=script&lang=js&"
import style0 from "./BedbuilderShareOptions.vue?vue&type=style&index=0&id=95c6d308&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c6d308",
  null
  
)

export default component.exports